import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { WidgetsContext, isDemo } from '../../GlobalContex';

import TopBar from '../builder/Interface/TopBar/TopBar';
import SettingsPanel from '../settings-panel/SettingsPanel';

import { usePageView } from '../../hooks/useAnalytics';

const Embed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { activeWidget } = useContext(WidgetsContext);
  const [buttonText, setButtonText] = useState('Copy');

  const handleClick = async () => {
    navigate('/home');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(activeWidget.code);
    setButtonText('Copied');
    setTimeout(() => setButtonText('Copy'), 3000);
  }

  usePageView('Embed');

  return (
    <>
      {!isDemo && <TopBar onClick={handleClick}>{t('Embed')}</TopBar>}
      <SettingsPanel>
        <Form>
          <Form.Group className="mb-3">
            <Form.Control as="textarea" rows={7} value={activeWidget.code} readOnly />
          </Form.Group>
          <Form.Group className='mb-3'>
            <Button variant={'primary'} className='w-100' onClick={handleCopy}>{t(buttonText)}</Button>
          </Form.Group>
        </Form>
      </SettingsPanel>
    </>
  );
};
export default Embed;
